module.exports = __webpack_public_path__ + "static/media/udubmc-wide.b996e125.png";